import React from 'react';
import { Link } from 'react-router-dom';
import { HubConsolidation } from '../components/structure/HubConsolidation';
import { PageTiers } from '../components/structure/PageTiers';
import { PageInventory } from '../components/structure/PageInventory';
import { EventsPlan } from '../components/structure/EventsPlan';
import { linkingRules, sitemap, squarespaceNotes, standalonePages } from '../data/architecture';
const evidence = [{
  page: '/',
  views: 380,
  time: '1:11',
  bounce: '72.5%',
  exit: '67.1%',
  read: 'Not routing people anywhere'
}, {
  page: '/family-events-santa-barbara',
  views: 260,
  time: '2:47',
  bounce: '79.0%',
  exit: '68.1%',
  read: 'Your best content — and a dead end'
}, {
  page: '/family-activities-in-santa-barbara',
  views: 249,
  time: '0:23',
  bounce: '54.9%',
  exit: '30.9%',
  read: 'Working as a doorway. Keep it scannable'
}, {
  page: '/kids-classes-sports-santa-barbara',
  views: 168,
  time: '0:27',
  bounce: '31.4%',
  exit: '17.3%',
  read: 'Healthiest page you have'
}, {
  page: '/santa-barbara-parks-playgrounds-kids',
  views: 156,
  time: '0:28',
  bounce: '62.1%',
  exit: '37.2%',
  read: 'Only two parks listed. Needs 25'
}, {
  page: '/…/sbcc-parenting-program',
  views: 111,
  time: '2:16',
  bounce: '73.8%',
  exit: '68.5%',
  read: 'Place pages hold attention. Build more'
}, {
  page: '/santa-barbara-family-attractions',
  views: 102,
  time: '0:29',
  bounce: '89.5%',
  exit: '25.5%',
  read: 'Worst bounce. Fold it in'
}, {
  page: '/santa-barbara-fitness-childcare',
  views: 82,
  time: '0:14',
  bounce: '50.0%',
  exit: '29.3%',
  read: 'One article, not a category'
}];
export function SiteStructure() {
  return <main id="main" className="bg-paper" data-id="element-1055" data-mp="35voka03h9c20">
      <header className="mx-auto max-w-shell px-6 pb-16 pt-20 lg:px-10 lg:pt-24" data-id="element-1056" data-mp="35sk6qc44h3yo">
        <p className="label text-olive" data-id="element-1057" data-mp="3ardo4fmj5f44">The build plan</p>
        <h1 className="mt-7 max-w-4xl font-display text-[52px] font-300 leading-[0.98] text-ink sm:text-[72px]" data-id="element-1058" data-mp="1bhdxryacutze">
          Seven hubs, sixty real pages, <span className="italic" data-id="element-1059" data-mp="1ghjisvm4di8i">and a calendar that runs itself</span>
        </h1>
        <p className="mt-8 max-w-prose text-[17px] leading-[1.85] text-muted" data-id="element-1060" data-mp="18f13a2wn1sjx">
          Keep the individual place pages — the numbers say they are the best
          thing on your site. Just stop treating every listing as one. Below:
          what happens to each of your ten existing categories, how much page
          each place actually deserves, the full build list in order, and how to
          handle events now that Tock is gone.
        </p>
      </header>

      <Evidence data-id="element-1061" data-mp="1nayud6rpg6pa" />
      <HubConsolidation data-id="element-1062" data-mp="1nbid2pp6iz4d" />
      <PageTiers data-id="element-1063" data-mp="1n9xemozquw18" />
      <Sitemap data-id="element-1064" data-mp="213ey69sfk8r9" />
      <PageInventory data-id="element-1065" data-mp="213y75103rmt5" />
      <EventsPlan data-id="element-1066" data-mp="2123lfkh0bqo0" />
      <Linking data-id="element-1067" data-mp="212n4x5mb2n45" />
      <Squarespace data-id="element-1068" data-mp="215j5l1pjfpwa" />

      <section className="border-t border-line bg-white" data-id="element-1069" data-mp="1w4ln0o0m8tu9">
        <div className="mx-auto max-w-shell px-6 py-20 text-center lg:px-10" data-id="element-1070" data-mp="1w53qo5plyac7">
          <p className="label text-olive" data-id="element-1071" data-mp="2b2dzf7av9248">See the templates</p>
          <div className="mt-8 flex flex-wrap justify-center gap-4" data-id="element-1072" data-mp="262rnr2aortxj">
            <Link to="/parks" className="label border border-ink/30 px-8 py-4 text-ink transition-colors duration-150 ease-soft hover:bg-ink hover:text-paper" data-id="element-1073" data-mp="260ey02yosf9x">
              Hub template
            </Link>
            <Link to="/place" className="label border border-ink/30 px-8 py-4 text-ink transition-colors duration-150 ease-soft hover:bg-ink hover:text-paper" data-id="element-1074" data-mp="2fqwv2lzr3z34">
              Tier 1 place page
            </Link>
          </div>
        </div>
      </section>
    </main>;
}
function Evidence() {
  return <section aria-labelledby="evidence-h" className="border-t border-line bg-white" data-id="element-1075" data-mp="2at55vzqhqr2m">
      <div className="mx-auto max-w-shell px-6 py-24 lg:px-10" data-id="element-1076" data-mp="1x170nzzwhfbq">
        <p className="label text-olive" data-id="element-1077" data-mp="21xxk8xawyt1w">
          Jan 1 – Aug 22, 2026 · 3,657 views · +59% yr/yr
        </p>
        <h2 id="evidence-h" className="mt-6 max-w-2xl font-display text-[40px] font-300 leading-[1.03] text-ink sm:text-[50px]" data-id="element-1078" data-mp="1n2hkqcrke4y4">
          Every decision below comes from this
        </h2>

        <div className="mt-14 overflow-x-auto" data-id="element-1079" data-mp="2vaxaehu5ze99">
          <table className="w-full min-w-[760px] border-collapse text-left" data-id="element-1080" data-mp="2qcm0k73vd3r1">
            <caption className="sr-only" data-id="element-1081" data-mp="2qeq0yf2k7kmk">
              Top pages by views with time on page, bounce rate, exit rate and
              the design implication
            </caption>
            <thead data-id="element-1082" data-mp="2gmak5l301239">
              <tr className="border-y border-ink/20" data-id="element-1083" data-mp="2gkpw8eb6whed">
                {['Page', 'Views', 'Time', 'Bounce', 'Exit', 'What it means'].map(h => <th key={h} scope="col" className="label py-4 pr-6 text-muted" data-id="element-1084" data-mp="27kt2vzduuucz">
                    {h}
                  </th>)}
              </tr>
            </thead>
            <tbody data-id="element-1085" data-mp="1xohrdbm3a8jl">
              {evidence.map(row => <tr key={row.page} className="border-b border-line" data-id="element-1086" data-mp="1xq18t5jhepmy">
                  <th scope="row" className="max-w-[240px] py-5 pr-6 text-[13px] font-400 text-ink" data-id="element-1087" data-mp="uwgbm4btwud">
                    {row.page}
                  </th>
                  <td className="py-5 pr-6 text-[14px] text-ink" data-id="element-1088" data-mp="3drqmmt7lvxj">{row.views}</td>
                  <td className="py-5 pr-6 text-[14px] text-ink" data-id="element-1089" data-mp="8dcoetwn7y8o">{row.time}</td>
                  <td className="py-5 pr-6 text-[14px] text-muted" data-id="element-1090" data-mp="d6p2ia3p4mn6">{row.bounce}</td>
                  <td className="py-5 pr-6 text-[14px] text-muted" data-id="element-1091" data-mp="i5a52g6f7ies">{row.exit}</td>
                  <td className="py-5 pr-6 text-[14px] leading-relaxed text-ink/75" data-id="element-1092" data-mp="3gmmcahxy3skz">
                    {row.read}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </section>;
}
function Sitemap() {
  return <section aria-labelledby="map-h" className="bg-opal/30" data-id="element-1093" data-mp="3vjn6qt7iu1n5">
      <div className="mx-auto max-w-shell px-6 py-24 lg:px-10 lg:py-28" data-id="element-1094" data-mp="3vl822l1ntom2">
        <p className="label text-ink/60" data-id="element-1095" data-mp="15v4h4vix12xz">The map</p>
        <h2 id="map-h" className="mt-6 max-w-2xl font-display text-[40px] font-300 leading-[1.03] text-ink sm:text-[52px]" data-id="element-1096" data-mp="15wnuoed6szw2">
          Home, seven hubs, everything else beneath them
        </h2>
        <p className="mt-7 max-w-prose text-[16px] leading-[1.85] text-ink/70" data-id="element-1097" data-mp="31xpvp8v8fl0u">
          Nothing sits more than two clicks from Home, and nothing lives outside
          a hub. If something new has no obvious parent, that is a sign it
          belongs as a category inside an existing hub — not as an eighth one.
        </p>

        <div className="mt-16 border-t border-ink/20 pt-10" data-id="element-1098" data-mp="2o74avem7x10b">
          <p className="label text-ink" data-id="element-1099" data-mp="2j6yitxc1dchp">sbwithkids.com /</p>
          <ul className="mt-12 grid gap-x-14 gap-y-14 sm:grid-cols-2 lg:grid-cols-4" data-id="element-1100" data-mp="2j8j7x7fl0386">
            {sitemap.map(node => <li key={node.path} data-id="element-1101" data-mp="2x07nxlsybbuf">
                <h3 className="font-display text-[25px] font-300 leading-tight text-ink" data-id="element-1102" data-mp="2s7eggq63lpen">
                  {node.label}
                </h3>
                <p className="mt-2 break-all text-[11px] leading-relaxed text-ink/50" data-id="element-1103" data-mp="24g944kzd9f93">
                  {node.path}
                </p>

                <p className="label mt-6 text-ink/50" data-id="element-1104" data-mp="1qctkiabw67ff">Categories</p>
                <p className="mt-2 text-[13px] leading-relaxed text-ink/70" data-id="element-1105" data-mp="1qagtz8s2ioqr">
                  {node.categories.join(' · ')}
                </p>

                <p className="label mt-5 text-ink/50" data-id="element-1106" data-mp="1gf5e2n4xbbhf">Pages beneath</p>
                <ul className="mt-2 space-y-1.5 border-l border-ink/20 pl-4" data-id="element-1107" data-mp="1ldgop031lq0p">
                  {node.children.map(child => <li key={child} className="text-[13.5px] leading-snug text-ink/75" data-id="element-1108" data-mp="292ruivz92alp">
                      {child}
                    </li>)}
                  <li className="text-[13px] italic text-ink/45" data-id="element-1109" data-mp="2dzrwaup2gr70">+ more, weekly</li>
                </ul>
              </li>)}
          </ul>
        </div>

        <div className="mt-16 border-t border-ink/20 pt-10" data-id="element-1110" data-mp="242dht0mpechc">
          <p className="label text-ink/60" data-id="element-1111" data-mp="np6vnal8iclq">Standalone, outside the hubs</p>
          <ul className="mt-6 flex flex-wrap gap-x-10 gap-y-3" data-id="element-1112" data-mp="soruzm4bgmyz">
            {standalonePages.map(p => <li key={p} className="text-[14px] text-ink/75" data-id="element-1113" data-mp="9xz60h61ske6">
                {p}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}
function Linking() {
  return <section aria-labelledby="link-h" className="bg-paper" data-id="element-1114" data-mp="3w5791cthwf71">
      <div className="mx-auto max-w-shell px-6 py-24 lg:px-10 lg:py-28" data-id="element-1115" data-mp="25jc4ym7aio">
        <p className="label text-olive" data-id="element-1116" data-mp="3s56pxevgbftn">Step five · Internal linking</p>
        <h2 id="link-h" className="mt-6 max-w-2xl font-display text-[40px] font-300 leading-[1.03] text-ink sm:text-[52px]" data-id="element-1117" data-mp="sp9w4w3y8t50">
          Five rules that hold it together
        </h2>
        <ol className="mt-16 grid gap-x-16 gap-y-12 border-t border-line pt-14 sm:grid-cols-2 lg:grid-cols-3" data-id="element-1118" data-mp="ixvn9xq3ygz7">
          {linkingRules.map((rule, i) => <li key={rule.rule} data-id="element-1119" data-mp="eviro252rzg5" data-mpi={i}>
              <p className="font-display text-[32px] font-300 leading-none text-ink/30" data-id="element-1120" data-mp="1bfhrgs1eqfan">
                {String(i + 1).padStart(2, '0')}
              </p>
              <h3 className="mt-5 font-display text-[25px] font-300 leading-tight text-ink" data-id="element-1121" data-mp="16mon459up8z3">
                {rule.rule}
              </h3>
              <p className="mt-3 text-[14.5px] leading-[1.8] text-muted" data-id="element-1122" data-mp="2u9kmfk5si24z">
                {rule.why}
              </p>
            </li>)}
        </ol>
      </div>
    </section>;
}
function Squarespace() {
  return <section aria-labelledby="sqsp-h" className="border-t border-line bg-white" data-id="element-1123" data-mp="33btywfkmc5l0">
      <div className="mx-auto max-w-shell px-6 py-24 lg:px-10 lg:py-28" data-id="element-1124" data-mp="3892gadxy05l7">
        <p className="label text-olive" data-id="element-1125" data-mp="3d8ylggidm32c">Step six · Building it</p>
        <h2 id="sqsp-h" className="mt-6 max-w-2xl font-display text-[40px] font-300 leading-[1.03] text-ink sm:text-[52px]" data-id="element-1126" data-mp="3d73ykwnjo0vm">
          How this maps onto Squarespace
        </h2>
        <div className="mt-16 grid gap-x-16 gap-y-14 border-t border-line pt-14 sm:grid-cols-2 lg:grid-cols-3" data-id="element-1127" data-mp="3m3cyecffp1ia">
          {squarespaceNotes.map(note => <div key={note.title} data-id="element-1128" data-mp="3w0hlqfl0n30o">
              <h3 className="font-display text-[25px] font-300 leading-tight text-ink" data-id="element-1129" data-mp="3vxlkoidvfy80">
                {note.title}
              </h3>
              <p className="mt-4 text-[14.5px] leading-[1.85] text-muted" data-id="element-1130" data-mp="1epndam8ok6rb">
                {note.body}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}